var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.container, { [_vm.stateDisabled]: _vm.disabled, [_vm.hasRadius]: _vm.hasBorderRadius } ],on:{"click":_vm.onClick}},[_c('span',{class:_vm.before},[_vm._t("before")],2),_c('div',{class:_vm.main},[_vm._t("default")],2),_c('span',{class:_vm.after},[_vm._t("after")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }